module.exports = __webpack_public_path__ + "img/about-icon-5.6b39dd13.png";